export default {
    bitacoraId(state) {
      return state.bitacoraId;
    },
    token(state) {
      return state.token;
    },
    isAuthenticated(state) {
      //console.log(state);
      return !!state.token;
    },
    didAutoLogout(state) {
      return state.didAutoLogout;
    },
  };
  